module.exports = {
    googlePlayStore: "https://play.google.com/store/apps/details?id=au.com.whydocumentaries.yesterdaystories",
    appStore: "https://apps.apple.com/au/app/yesterday-stories/id1382978257",
};